module.exports = __webpack_public_path__ + "static/media/upload-btn@2x.e265aba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/upload-btn@2x.png
// module id = 918
// module chunks = 0